'use client'
import React from 'react'
import Typography from 'src/components/design-system/Typography'
import Tag from 'src/components/design-system/Tag'
import { useTranslateEntry } from 'src/i18n/client/useTranslateEntry'
import LINKS from 'src/_helpers/links'
import useJournalDomainRoutes from 'src/components/journals/domain/useJournalDomainRoutes'
import { buildLocalizedPath } from 'src/_helpers/localizedLinks'
import Link from 'next/link'
import { getPreferredTranslation } from 'src/_helpers/getPreferredTranslation'

const Top = ({ page, locale, routeContext = 'main' }) => {
  const translate = useTranslateEntry()
  const journalRoutes = useJournalDomainRoutes()
  const publicationTypes = page.publicationTypes || []
  const journalTranslation = getPreferredTranslation(page?.journal, locale) || {}
  const journalSlug = journalTranslation?.slug || ''
  const journalRoute = routeContext === 'journal-domain' ? journalRoutes.HOME : LINKS.JOURNALS.DETAIL
  const journalLink = buildLocalizedPath(journalRoute, locale, { slug: journalSlug })
  const journalTitle = journalTranslation?.title || ''
  const publicationStatus = getPreferredTranslation(page.publicationStatus, locale)?.title || null
  const isDomainJournal = routeContext === 'journal-domain'
  return (
    <div className="flex flex-col gap-y-64 mb-24 col-span-full">
      <div className="flex flex-col gap-y-16">
        {publicationStatus && (
          <div className="flex items-center gap-x-12">
            <Typography variant="body3" component="span" color="text-basic-black">
              {translate('T_STATUS')}
            </Typography>
            <Typography
              variant="body3"
              component="span"
              color="text-basic-black"
              className="bg-green-green5 block py-4 px-11 rounded-8"
            >
              {publicationStatus}
            </Typography>
          </div>
        )}
        {publicationTypes.length > 0 && (
          <div className="flex items-center gap-x-8 flex-wrap">
            {publicationTypes.map((type, index) => {
              const title = getPreferredTranslation(type, locale)?.title
              if (!title) return null
              return (
                <React.Fragment key={index}>
                  <Tag
                    type="default"
                    label={title}
                    className={isDomainJournal ? 'bg-basic-gray8 text-basic-black' : ''}
                  />
                </React.Fragment>
              )
            })}
          </div>
        )}
      </div>
      {journalLink && journalTitle && (
        <Link href={journalLink} className="group">
          <Typography
            variant="h2"
            component="span"
            color="text-dark-blue-dark-blue1"
            className="block w-fit h-fit relative after:content-[''] after:h-1 after:w-0 after:transition-[width] after:absolute after:bottom-0 after:left-0 group-hover:after:w-full after:bg-dark-blue-dark-blue1"
          >
            {journalTitle}
          </Typography>
        </Link>
      )}
    </div>
  )
}

export default Top
